<template>
  <div>
    <HazardLegend />
    <b-table-lite
      v-if="scoreRecords"
      :fields="scoreRecordFields"
      :items="scoreRecords"
      hover
    >
      <template #cell(source)="data">
        {{ data.value }}
        <span v-if="data.item.sourceOriginal">({{ data.item.sourceOriginal }})</span>
      </template>
      <template #cell(score)="data">
        <div
          :class="{
            'table-danger': data.value === 'VH',
            'table-danger': data.value === 'VH',
            'table-orange': data.value === 'H',
            'table-warning-light': data.value === 'M',
            'table-success': data.value === 'L',
            'authoritative': data.item.listType === 'Authoritative',
            'screening': data.item.listType === 'Screening' || data.item.listType === 'QSAR Experimental',
            'predicted': data.item.listType === 'QSAR Model',
            'score-records-cell': true,
          }"
        >
          {{ data.value }}
        </div>
      </template>
      <template #cell(rationale)="data">
        <span v-html="data.value" />
      </template>
      <template #cell(note)="data">
        <span v-html="data.value" />
      </template>
    </b-table-lite>
  </div>
</template>

<script>
import HazardLegend from './HazardLegend.vue'

export default {
  components: { HazardLegend },

  filters: {
    floatDecimal(value) {
      return isNaN(value) ? value : value.toFixed(2)
    },
  },

  props: {
    scoreRecords: {
      type: [Array, null],
    },
    hazardName: {
      type: String,
      required: true,
    },
    scoreStructure: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      scoreRecordFields: [
        { key: 'source', sortable: true },
        { key: 'score', sortable: true },
        { key: 'route', sortable: true },
        { key: 'testOrganism', sortable: true },
        { key: 'testType', sortable: true },
        { key: 'category', sortable: true },
        { key: 'hazardCode', sortable: true },
        { key: 'hazardStatement' },
        { key: 'rationale' },
        { key: 'note' },
      ],
    }
  },
}
</script>

<style scoped>
tr:first-child {
  background: rgba(0, 0, 80, 0.1);
}

.score-records-cell {
  text-align: center;
  height: 100% !important;
}
</style>
